import { render, staticRenderFns } from "./BlogPosts.vue?vue&type=template&id=6da621e8&"
import script from "./BlogPosts.vue?vue&type=script&lang=ts&"
export * from "./BlogPosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports